import React from 'react';
import { Select, Tag } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { FieldLabel, ErrorText } from './styles';
import type { SchedulesSelectorProps } from './types';
import { PLACEHOLDERS } from './constants';

type TagProps = { label: React.ReactNode; onClose: () => void; closable: boolean };

const tagRender = (props: TagProps) => {
  const { label, onClose } = props;
  return (
    <Tag
      color="blue"
      closable
      onClose={onClose}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 10px',
        borderRadius: 20,
        fontSize: 13,
        fontWeight: 500,
        margin: '2px 4px 2px 0',
        lineHeight: '22px',
      }}
    >
      {label}
    </Tag>
  );
};

const SchedulesSelector: React.FC<SchedulesSelectorProps> = ({
  schedules,
  selectedSchedules,
  onScheduleChange,
  error,
}) => {
  const handleChange = (selectedIds: string[]) => {
    onScheduleChange(schedules.filter((s) => selectedIds.includes(s.id)));
  };

  return (
    <div>
      <FieldLabel>Schedules <span style={{ color: '#ff4d4f' }}>*</span></FieldLabel>
      <Select
        mode="multiple"
        showSearch
        allowClear
        tagRender={tagRender}
        placeholder={PLACEHOLDERS.SELECT_SCHEDULES}
        value={selectedSchedules.map((s) => s.id)}
        onChange={handleChange}
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        options={schedules.map((s) => ({
          value: s.id,
          label: `${s.day_names.join(', ')} · ${s.start_time} - ${s.end_time}`,
        }))}
        optionRender={(option) => {
          const schedule = schedules.find((s) => s.id === option.value);
          if (!schedule) return option.label;
          return (
            <div>
              <div style={{ fontWeight: 500 }}>{schedule.day_names.join(', ')}</div>
              <div style={{ fontSize: 12, opacity: 0.6, display: 'flex', alignItems: 'center', gap: 4 }}>
                <ClockCircleOutlined />
                {schedule.start_time} - {schedule.end_time}
              </div>
            </div>
          );
        }}
        style={{ width: '100%', minHeight: 40 }}
        status={error ? 'error' : ''}
      />
      {error && <ErrorText>{error}</ErrorText>}
    </div>
  );
};

export default React.memo(SchedulesSelector);
